import { render, staticRenderFns } from "./articles-index.vue?vue&type=template&id=a1c82df0&"
import script from "./articles-index.vue?vue&type=script&lang=js&"
export * from "./articles-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports